import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import Table from "react-bootstrap/Table"
import { toast } from "react-toastify"

import { selectTranslations } from "../../../services/i18n/i18nSlice"
import { fetchUsersCommunications } from "../CommunicationsApi"
import { fetchUser } from "../../UsersScreen/UsersApi"

const LIMIT = 50

export default function UserCommunicationsList ({communicationId}) {

    const t = useSelector(selectTranslations)
    const [userCommunications, setUserCommunications] = useState([])
    const [nextCursor, setNextCursor] = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    const loadUserCommunications = async (cursor = null) => {
        setIsLoading(true)
        const response = await fetchUsersCommunications(communicationId, {limit: LIMIT, ...(cursor && {start_cursor: cursor})})
        if(response.success){
            // ponytail: one get_user call per row, a bulk users endpoint would avoid it on big pages
            const users = await Promise.all(response.data.user_communications.map(uc => fetchUser(uc.user_id)))
            const rows = response.data.user_communications.map((uc, i) => ({...uc, user: users[i].success ? users[i].data : null}))
            setUserCommunications(cursor ? [...userCommunications, ...rows] : rows)
            setNextCursor(response.data.user_communications.length === LIMIT ? response.data.next_cursor : null)
        } else {
            toast.error(response.error || t.error.error_loading)
        }
        setIsLoading(false)
    }

    useEffect(()=>{
        if(communicationId)
            loadUserCommunications()
    },[communicationId])

    return (
        <div className='info_card'>
            <h2>{t.communications.views}</h2>
            {userCommunications.length === 0 && !isLoading ?
                <p className="text-muted">{t.communications.no_views}</p> :
                <>
                    <p>{t.communications.viewed_count.replace('{viewed}', userCommunications.filter(uc => uc.viewed).length).replace('{total}', userCommunications.length)}</p>
                    <Table hover responsive>
                        <thead>
                            <tr>
                                <th>E-mail</th>
                                <th>{t.users.fields.firstname}</th>
                                <th>{t.users.fields.lastname}</th>
                                <th>{t.communications.viewed}</th>
                                <th>{t.communications.view_date}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {userCommunications.map((uc)=>(
                                <tr key={uc.user_id}>
                                    <td>{uc.user?.email || uc.user_id}</td>
                                    <td>{uc.user?.firstname}</td>
                                    <td>{uc.user?.lastname}</td>
                                    <td>{uc.viewed ? t.user.yes : t.user.no}</td>
                                    <td>{uc.view_date ? new Date(uc.view_date).toLocaleString() : '-'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </>
            }
            {nextCursor &&
                <button className="secondary mx-auto d-block" disabled={isLoading} onClick={()=>loadUserCommunications(nextCursor)}>{t.ofa.load_more}</button>
            }
        </div>
    )
}
